export const unhandledTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  menuWidth: 180,
  align: 'center',
  refreshBtn: false,
  showClomnuBtn: false,
  searchSize: 'mini',
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  props: {
    label: 'label',
    value: 'value'
  },
  column: [{
    label: '举报者Full Name',
    width: 140,
    prop: 'complainedBy',
    solt: true
  }, {
    label: '举报者Birth Name',
    width: 140,
    prop: 'complainedByRealname',
    solt: true
  }, {
    label: '被举报者Full Name',
    width: 160,
    prop: 'complainedTo',
    solt: true
  }, {
    label: '被举报者Birth Name',
    width: 160,
    prop: 'complainedToRealname',
    solt: true
  }, {
    label: '举报分类',
    prop: 'label',
    width: 120
  }, {
    label: '举报描述',
    prop: 'reason',
    width: 200,
    overHidden: true
  }, {
    label: '举报附件',
    prop: 'thumbnailUrl',
    solt: true
  }, {
  //   width: 80,
  //   label: '被举报内容类别',
  //   prop: 'targetType',
  //   solt: true
  // }, {
    width: 280,
    label: '被举报内容',
    prop: 'content',
    solt: true,
    overHidden: true
  }, {
    width: 80,
    label: '状态',
    prop: 'handleResult',
    hide: true,
    solt: true
  }, {
    width: 150,
    label: '投诉时间',
    prop: 'complainedTime',
    type: 'datetime',
    format: 'yyyy-MM-dd HH:mm',
    valueFormat: 'yyyy-MM-dd HH:mm:ss'
  }]
}

export const handledTableOption = {
  border: true,
  stripe: true,
  menu: false,
  menuAlign: 'center',
  menuWidth: 180,
  align: 'center',
  refreshBtn: false,
  showClomnuBtn: false,
  searchSize: 'mini',
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  props: {
    label: 'label',
    value: 'value'
  },
  column: [{
    label: '举报者Full Name',
    width: 140,
    prop: 'complainedBy',
    solt: true
  }, {
    label: '举报者Birth Name',
    width: 140,
    prop: 'complainedByRealname',
    solt: true
  }, {
    label: '被举报者Full Name',
    width: 160,
    prop: 'complainedTo',
    solt: true
  }, {
    label: '被举报者Birth Name',
    width: 160,
    prop: 'complainedToRealname',
    solt: true
  }, {
    label: '举报分类',
    prop: 'label',
    width: 120
  }, {
    label: '举报描述',
    prop: 'reason',
    width: 200,
    overHidden: true
  }, {
    label: '举报附件',
    prop: 'thumbnailUrl',
    solt: true
  }, {
  //   width: 80,
  //   label: '被举报内容类别',
  //   prop: 'targetType',
  //   solt: true
  // }, {
    width: 280,
    label: '被举报内容',
    prop: 'content',
    solt: true,
    overHidden: true
  }, {
    width: 80,
    label: '状态',
    prop: 'handleResult',
    solt: true
  }, {
    width: 80,
    label: '自动下架',
    prop: 'autoBan',
    solt: true
  }, {
    width: 150,
    label: '投诉时间',
    prop: 'complainedTime',
    type: 'datetime',
    format: 'yyyy-MM-dd HH:mm',
    valueFormat: 'yyyy-MM-dd HH:mm:ss'
  }]
}

export const targeTypes = [
  {label: '内容', value: 0},
  {label: '评论', value: 1}
]

export const status = [
  {label: '已忽略', value: 1},
  {label: '已下架', value: 2}
]
